module.exports = __webpack_public_path__ + "7528c4835c12526f3d9068c66e520cc9.svg";